import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetogoacabpackages() {



  const cardData =
  {
    keyword: 'Pune to Goa Cab Package',
    heading: 'Sanavi Travels: Pune to Goa Cab Package',
    headingDescription: 'Sanavi Travels offers reliable Pune to Goa Cab Package, providing safe, comfortable, and hassle-free transportation for families, friends, couples, and corporate travelers planning a long-distance trip from Pune to Goa. Our fleet of well-maintained sedans, SUVs, and luxury cabs ensures spacious seating, air-conditioning, and ample luggage space for a smooth and relaxing journey. With professional chauffeurs, flexible one-way and round-trip cab packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free travel. We provide convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering popular Goa destinations such as North Goa, South Goa, Calangute, Baga, Anjuna, Candolim, Panaji, and Madgaon. Choose Sanavi Travels for trusted Pune to Goa cab packages, delivering comfort, safety, and a memorable travel experience.',

    top: 'Top Places to Visit in Goa with Sanavi Travels',


"topPlaces": [
  {
    "title": "Baga Beach",
    "description": "Baga Beach is one of Goa’s most popular beaches, known for its vibrant nightlife, beach shacks, and water sports. Visitors can enjoy parasailing, jet skiing, banana boat rides, and lively parties. It is a perfect destination for fun, food, and entertainment."
  },
  {
    "title": "Calangute Beach",
    "description": "Calangute Beach, often called the 'Queen of Beaches', is famous for its golden sands, bustling atmosphere, and seaside resorts. It attracts families, honeymooners, and adventure lovers alike. Shopping stalls and beach activities add to its charm."
  },
  {
    "title": "Anjuna Beach",
    "description": "Anjuna Beach is known for its laid-back vibe, scenic rocky shoreline, and famous flea market. It is a favorite among backpackers and travelers looking for relaxed beach time, sunset views, and nightlife experiences."
  },
  {
    "title": "Dudhsagar Waterfalls",
    "description": "Dudhsagar Waterfalls is one of India’s tallest waterfalls, located on the Goa–Karnataka border. The milky white cascading water surrounded by dense forests creates a spectacular sight, especially during the monsoon. It is a must-visit natural attraction near Goa."
  },
  {
    "title": "Basilica of Bom Jesus",
    "description": "The Basilica of Bom Jesus in Old Goa is a UNESCO World Heritage Site, famous for housing the mortal remains of St. Francis Xavier. The church’s baroque architecture and historical significance make it one of Goa’s most important landmarks."
  },
  {
    "title": "Fort Aguada",
    "description": "Fort Aguada is a well-preserved 17th-century Portuguese fort overlooking the Arabian Sea. Built to protect Goa from invasions, it offers stunning sea views and is a popular spot for sightseeing and photography."
  },
  {
    "title": "Palolem Beach",
    "description": "Palolem Beach is a serene and picturesque beach in South Goa, known for its crescent-shaped shoreline and calm waters. It is ideal for swimming, kayaking, yoga retreats, and peaceful relaxation away from crowds."
  },
  {
    "title": "Chapora Fort",
    "description": "Chapora Fort, made famous by Bollywood, offers panoramic views of the Vagator Beach and Arabian Sea. The fort is a popular sunset viewpoint and a favorite spot for photography and exploration."
  },
  {
    "title": "Old Goa Churches",
    "description": "Old Goa is home to several historic churches and convents that reflect Portuguese colonial heritage. The area is rich in history, architecture, and culture, making it a must-visit for heritage lovers."
  },
  {
    "title": "Cruise on Mandovi River",
    "description": "A cruise on the Mandovi River offers a relaxing experience with live music, dance performances, and scenic views of Panaji. Evening cruises are especially popular, providing entertainment and a glimpse of Goa’s vibrant culture."
  }
]
,




"services": [
  {
    "name": "Pune to Goa Cab Package",
    "description": "Pune to Goa Cab Package offers a comfortable, safe, and convenient travel solution for travelers planning a long-distance coastal journey. Fully air-conditioned cabs with spacious seating, smooth suspension, and ample luggage space make the drive relaxing and enjoyable. Experienced chauffeurs ensure safe driving, proper route planning, and timely pickups. Ideal for families, friends, couples, and corporate travelers, this package is perfect for holidays, weekend getaways, beach vacations, and leisure trips to Goa."
  },
  {
    "name": "Goa Cab from Pune",
    "description": "Goa Cab from Pune provides a reliable and hassle-free option for traveling from Pune to Goa by road. Well-maintained, air-conditioned vehicles with comfortable interiors ensure a smooth journey across long distances. Professional drivers handle highways and ghat sections safely, making the trip stress-free. Suitable for families, groups, and solo travelers, this service focuses on comfort, punctuality, and safety."
  },
  {
    "name": "AC Cab Pune to Goa",
    "description": "AC Cab Pune to Goa ensures a cool and comfortable journey, especially during long hours of travel and summer seasons. Fully air-conditioned vehicles offer spacious seating, smooth rides, and sufficient luggage capacity. Skilled chauffeurs ensure safe driving and efficient route management. Ideal for tourists, families, and couples looking for a relaxed and comfortable Goa road trip."
  },
  {
    "name": "Luxury Cab Goa Trip",
    "description": "Luxury Cab Goa Trip delivers a premium travel experience with stylish, high-end vehicles and modern interiors. Fully air-conditioned luxury cabs provide superior comfort, smooth performance, and a refined journey. Professional chauffeurs ensure punctuality, safety, and personalized service. Perfect for couples, corporate travelers, and families seeking a high-end and comfortable Pune to Goa travel experience."
  },
  {
    "name": "Family Cab Goa",
    "description": "Family Cab Goa is designed for families traveling together from Pune to Goa. Spacious cabs with air-conditioning, comfortable seating, and ample luggage space ensure a pleasant journey for all age groups. Experienced drivers prioritize safety and smooth driving, making this service ideal for family vacations, beach holidays, and extended stays in Goa."
  },
  {
    "name": "Outstation Cab Goa",
    "description": "Outstation Cab Goa offers dependable long-distance travel from Pune to Goa. Fully air-conditioned, well-maintained vehicles with professional chauffeurs ensure a smooth and secure journey. Available for one-way or round trips, this service is suitable for tourists, families, and corporate travelers seeking reliable outstation travel with flexible plans."
  },
  {
    "name": "Affordable Cab Goa",
    "description": "Affordable Cab Goa provides budget-friendly travel options without compromising on comfort or safety. Air-conditioned cabs with professional drivers ensure a pleasant and economical journey from Pune to Goa. Ideal for students, families, and group travelers, this service combines affordability, reliability, and convenience for long-distance travel."
  },
  {
    "name": "Chauffeur Driven Cab Goa",
    "description": "Chauffeur Driven Cab Goa ensures a stress-free journey with experienced drivers handling navigation, traffic, and long-distance driving. Spacious, air-conditioned vehicles allow passengers to relax and enjoy the ride. Suitable for families, tourists, and corporate travelers, this service emphasizes professionalism, safety, and comfort throughout the Pune to Goa trip."
  },
  {
    "name": "Best Cab Pune to Goa",
    "description": "Best Cab Pune to Goa offers a premium and dependable travel experience with well-maintained vehicles and professional chauffeurs. Fully air-conditioned cabs ensure comfort on long drives, while punctual service and safe driving enhance convenience. Ideal for families, couples, and tourists seeking the best road travel option to Goa."
  },
  {
    "name": "Pune Goa Taxi",
    "description": "Pune Goa Taxi is a trusted solution for long-distance road travel. Spacious, air-conditioned taxis with experienced drivers provide comfort, safety, and reliability. Flexible pickup and drop locations make this service suitable for families, groups, and tourists planning a relaxed and hassle-free Goa journey."
  },
  {
    "name": "Tourist Cab Goa",
    "description": "Tourist Cab Goa is ideal for travelers planning sightseeing, leisure travel, or beach holidays. Comfortable, air-conditioned cabs with knowledgeable chauffeurs ensure smooth travel and familiarity with routes. Suitable for families, couples, and groups, this service supports flexible itineraries and enjoyable long-distance journeys."
  },
  {
    "name": "Long Distance Cab Pune",
    "description": "Long Distance Cab Pune specializes in safe and comfortable long-distance travel such as Pune to Goa. Air-conditioned vehicles with experienced chauffeurs ensure stress-free journeys over extended hours. Ideal for family vacations, group tours, and leisure trips, this service focuses on comfort, reliability, and punctuality."
  },
  {
    "name": "One Way Cab Goa",
    "description": "One Way Cab Goa offers a cost-effective and convenient option for travelers heading from Pune to Goa without a return requirement. Fully air-conditioned vehicles and professional drivers ensure a smooth, safe, and timely journey. Ideal for tourists, families, and solo travelers seeking flexible one-way travel solutions."
  },
  {
    "name": "Round Trip Cab Goa",
    "description": "Round Trip Cab Goa is perfect for travelers planning to return to Pune after their Goa vacation. Fully air-conditioned, well-maintained vehicles with professional chauffeurs ensure a comfortable and safe round journey. Suitable for family holidays, group travel, and corporate trips, this service provides flexibility, reliability, and convenience."
  },
  {
    "name": "Online Cab Booking Pune",
    "description": "Online Cab Booking Pune allows travelers to easily book Pune to Goa cabs anytime from anywhere. Customers can choose vehicle type, pickup and drop locations, travel dates, and trip type with instant confirmation. Fully air-conditioned vehicles with professional chauffeurs ensure a smooth, safe, and reliable journey with complete booking convenience."
  }
],
"tableData": [
  ["Pune to Goa Cab Package", "Goa Cab from Pune"],
  ["AC Cab Pune to Goa", "Luxury Cab Goa Trip"],
  ["Family Cab Goa", "Outstation Cab Goa"],
  ["Affordable Cab Goa", "Chauffeur Driven Cab Goa"],
  ["Best Cab Pune to Goa", "Pune Goa Taxi"],
  ["Tourist Cab Goa", "Long Distance Cab Pune"],
  ["One Way Cab Goa", "Round Trip Cab Goa"],
  ["Online Cab Booking Pune", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Goa Cab Package with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable cab packages from Pune to Goa, ideal for family vacations, group trips, beach holidays, and long-distance leisure travel."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Cabs",
    "WhyChoosedescription": "Travel in clean, air-conditioned, and regularly serviced cabs to enjoy a smooth and relaxing journey from Pune to Goa."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, professional, and experienced with the Pune to Goa route, ensuring safe and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for Pune to Goa cab packages, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel queries, and itinerary planning."
  },
  {
    "WhyChooseheading": "Flexible Cab Packages",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized Pune to Goa cab packages based on your travel plan and schedule."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Goa cab packages."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels offer Pune to Goa cab packages?',
    answer: 'Yes, Sanavi Travels provides comfortable and reliable cab packages from Pune to Goa.'
  },
  {
    question: 'How can I book a Pune to Goa cab package?',
    answer: 'You can book online through our website or contact our 24x7 customer support team for assistance.'
  },
  {
    question: 'What types of cabs are available for Pune to Goa travel?',
    answer: 'Sanavi Travels offers sedans, SUVs, and premium cars suitable for long-distance travel.'
  },
  {
    question: 'Are drivers experienced for the Pune to Goa route?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the Pune to Goa route.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations?',
    answer: 'Absolutely. You can select your preferred pickup location in Pune and drop-off anywhere in Goa.'
  },
  {
    question: 'Is the Pune to Goa cab service available 24x7?',
    answer: 'Yes, Sanavi Travels provides round-the-clock cab services to suit your travel schedule.'
  },
  {
    question: 'Are the vehicles sanitized before trips?',
    answer: 'Yes, all cabs are cleaned and sanitized before every journey.'
  },
  {
    question: 'What payment options are available for cab packages?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Goa trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Nikhil Pawar',
    feedback: 'Booked a Pune to Goa cab package with Sanavi Travels. Comfortable ride, professional driver, and excellent service throughout the journey.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Riya Desai',
    feedback: 'Wonderful experience! Clean cab, smooth drive, and very helpful customer support. Highly recommend Sanavi Travels for Pune to Goa travel.',
    rating: 5
  }
];

























































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Goa Cab Package - Sanavi Travels",
  "description": "Book Pune to Goa cabs with Sanavi Travels. AC and luxury cabs for family trips, outstation journeys, long-distance travel, one-way or round trips, tourist trips, and comfortable chauffeur-driven service.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Pune to Goa Cab Package | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury cabs from Pune to Goa with Sanavi Travels. Perfect for family trips, outstation journeys, long-distance travel, one-way or round trips, tourist trips, and safe chauffeur-driven service."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/67.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetogoacabpackages;